import { IDocumentosTemplate } from "../../../Interfaces/Geral/Documentos/DocumentosInterface";
import { ITemplate } from "../../../Interfaces/Geral/GestaoDeTemplates/GestaoDeTemplatesInterfaces";
import Axios from "../../Config/API";
import Service from "../../Service";

export function ListarTemplatesService() {
    return Service(
        Axios.get<Array<ITemplate>>(
            `/home/doctemplateform/listardoctemplateform`
        )
    );
}

export function DeletarTemplatesService(
    ID_DOCUMENTO_TEMPLATE_FORMULARIO: number
) {
    return Service(
        Axios.delete(
            `/home/doctemplateform/removedoctemplateform?id=${ID_DOCUMENTO_TEMPLATE_FORMULARIO}`
        )
    );
}

export function DeletarDocTemplatesService(ID_DOCUMENTO_TEMPLATE: number) {
    return Service(
        Axios.delete(
            `/home/documentos/deletardocumentotemplate?idDocumentoTemplate=${ID_DOCUMENTO_TEMPLATE}`
        )
    );
}

export function CriarTemplateService(requestBody: ITemplate) {
    return Service(
        Axios.post(`/home/doctemplateform/inserirdoctemplateform`, requestBody)
    );
}

export function AtualizaTemplateService(requestBody: IDocumentosTemplate) {
    return Service(
        Axios.put(`/home/documentos/atualizardocumentotemplate`, requestBody)
    );
}

export function AlteraStatusTemplateService(ID_DOCUMENTO_TEMPLATE: number) {
    return Service(
        Axios.put(`/home/documentos/alterarstatusdocumentotemplate?idDocumentoTemplate=${ID_DOCUMENTO_TEMPLATE}`)
    );
}
